import React from 'react';
import styled, { css } from 'styled-components';
import Label from './Label';
import Image from './Image';
import SelectOption from './SelectOption';
import Popover from './Popover';
import PermissionControlledComponent from "./PermissionControlledComponent";
import FeatureControlledComponent from "./FeatureControlledComponent";
const ArrowLeft = require('../assets/images/ui_arrow_left_gray.svg');
export var SelectHeaderSize;
(function (SelectHeaderSize) {
    SelectHeaderSize["EXTRA_SMALL"] = "EXTRA_SMALL";
    SelectHeaderSize["SMALL"] = "SMALL";
    SelectHeaderSize["MEDIUM"] = "MEDIUM";
    SelectHeaderSize["LARGE"] = "LARGE";
    SelectHeaderSize["INSET"] = "INSET";
})(SelectHeaderSize || (SelectHeaderSize = {}));
const DefaultDropdownIcon = () => {
    return React.createElement(DropdownCaret, { src: ArrowLeft, alt: 'Previous', width: "5px" });
};
const Select = ({ selectedElement, allElements, onChange, isReadOnly, isHidden, isValid = true, isOverflow = true, selectHeaderSize = SelectHeaderSize.LARGE, hasSelectHeaderElements = false, requireAllDirectPermissions, requireOneDirectPermission, requireFeature, className, HeaderWrapperComponent = DefaultHeaderWrapper, maxHeight = 500, HeaderComponent = DefaultHeaderComponent, SelectComponent = DefaultSelectComponent, OptionComponent = SelectOption, headerIcon = null, selectDropdownIcon = React.createElement(DefaultDropdownIcon, null), isBorderVisible = false, ChildrenWrapper, }) => {
    const headerElement = React.createElement(HeaderWrapperComponent, { selectHeaderSize: selectHeaderSize, isReadOnly: isReadOnly ? isReadOnly : false, isHidden: isHidden, isValid: isValid, isBorderVisible: isBorderVisible },
        React.createElement(HeaderComponent, { text: selectedElement.displayValue }),
        headerIcon,
        selectDropdownIcon);
    const childElements = React.createElement(SelectComponent, { isOverflow: isOverflow }, allElements.map((element, index) => {
        let SelectOptionComponent = element.optionComponent;
        if (!SelectOptionComponent) {
            SelectOptionComponent = OptionComponent;
        }
        let extras = element.extras;
        if (!extras) {
            extras = {};
        }
        if (hasSelectHeaderElements) {
            if (element.value === "-1") {
                return (React.createElement(SelectOptionComponent, { key: `${element.displayValue}_${index}`, disabled: true, text: element.displayValue, extras: extras }));
            }
            return (React.createElement(SelectHeaderChildComponent, { key: `${element.displayValue}_${index}`, disabled: element.disabled, onClick: () => {
                    onChange(element);
                }, text: element.displayValue, extras: extras }));
        }
        return (React.createElement(SelectOptionComponent, { key: `${element.displayValue}_${index}`, disabled: element.disabled, onClick: () => {
                onChange(element);
            }, text: element.displayValue, extras: extras }));
    }));
    return React.createElement(FeatureControlledComponent, { requireFeature: requireFeature },
        React.createElement(PermissionControlledComponent, { requireAllDirectPermissions: requireAllDirectPermissions, requireOneDirectPermission: requireOneDirectPermission }, isReadOnly ?
            headerElement
            :
                React.createElement(Popover, { HeaderComponent: headerElement, ChildrenComponent: childElements, PopoverWrapper: SelectPopover, shadowCss: '0 0 40px 0 rgba(90,97,102,0.15), 0 2px 10px 0 rgba(90,97,102,0.15), 0 1px 2px 0 rgba(90,97,102,0.15);', className: className, hideOnChildrenClicked: true, ChildrenWrapper: ChildrenWrapper })));
};
const SelectHeaderChildComponent = styled(SelectOption) `
    margin-left: 20px;
`;
const SelectPopover = styled.div `
  font-size: 14px;
  color: #1E222B;
  
  cursor: pointer;
  
  background-color: ${props => props.theme.colors.white};
`;
const DefaultHeaderWrapper = styled("div") `
  display: flex;
  display: ${props => props.isHidden && 'none'};
  align-items: center;
  justify-content: space-between;

  min-width: 50px;
  text-align: center;

  ${props => props.selectHeaderSize === SelectHeaderSize.EXTRA_SMALL && ExtraSmallHeaderWrapperStyling};
  ${props => props.selectHeaderSize === SelectHeaderSize.SMALL && SmallHeaderWrapperStyling};
  ${props => props.selectHeaderSize === SelectHeaderSize.MEDIUM && MediumHeaderWrapperStyling};
  ${props => props.selectHeaderSize === SelectHeaderSize.LARGE && LargeHeaderWrapperStyling};
  ${props => props.selectHeaderSize === SelectHeaderSize.INSET && InsetHeaderWrapperStyling};

  opacity: 1;
  opacity: ${props => props.isReadOnly && '0.6'};
  border: 1px solid ${props => props.isValid ? props.theme.colors.silverLight : props.theme.colors.textOrange};
  border: ${props => props.isBorderVisible && 'none'};
  border-radius: 3px;
  background-color: ${props => props.theme.colors.white};
`;
export const ExtraSmallHeaderWrapperStyling = css `
    justify-content: center;

    height: auto;
    padding: 0;
`;
export const SmallHeaderWrapperStyling = css `
    justify-content: center;

    height: auto;
    padding: 6px 12px;
`;
export const MediumHeaderWrapperStyling = css `
    justify-content: center;

    height: auto;
    padding: 10px 12px;
`;
export const LargeHeaderWrapperStyling = css `
    height: 32px;
    line-height: 32px;
    padding: 5px 12px;
`;
export const InsetHeaderWrapperStyling = css `
    justify-content: space-between;
    
    padding: 0 5px;
`;
const DefaultHeaderComponent = styled(Label) `
  margin-right: 5px;

  color: ${props => props.theme.colors.tertiaryText};
`;
const DefaultSelectComponent = styled("ul") `
  margin: 0;
  padding: 0;

  max-height: ${props => props.maxHeight && props.maxHeight}px;
  overflow-y: visible;
  overflow-y: ${props => props.isOverflow && 'auto'};
  
  list-style-type: none;
`;
const DropdownCaret = styled(Image) `
  transform: rotate(-45deg);
`;
export default Select;
//# sourceMappingURL=Select.js.map